<script setup lang="ts">
import {ModelDetail} from '@jantm/model-core'
import Dashboard from "@/components/WiserDashboardComponent.vue";
import {computed} from "vue";
const props = defineProps({
  id: {
    type: Number,
    required: true,
  }
})
const identifier = computed(() => String(props.id))
</script>

<template>
  <Dashboard />
  <div class="container">
    <ModelDetail class="model-detail model-detail-invoice" model="Invoice" :identifier="identifier" />
  </div>
</template>

<style scoped></style>
